export default "__VITE_ASSET__CB$wrmlm__"